import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchLoginUser } from "../../services/callApi";

const ManagerUserContext = createContext(null);

export function ManagerUserProvider({ children }) {
  const { pathname } = useLocation();
  const isManagerPage = pathname.startsWith("/manager");
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(isManagerPage);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isCurrent = true;

    if (!isManagerPage) {
      setAdminUser(null);
      setError(null);
      setLoading(false);
      return () => {
        isCurrent = false;
      };
    }

    const loadManagerUser = async () => {
      setLoading(true);
      try {
        const loginUser = await fetchLoginUser();
        if (isCurrent) {
          setAdminUser(loginUser);
          setError(null);
        }
      } catch (loadError) {
        if (isCurrent) {
          setAdminUser(null);
          setError(loadError);
        }
      } finally {
        if (isCurrent) {
          setLoading(false);
        }
      }
    };

    loadManagerUser();

    return () => {
      isCurrent = false;
    };
  }, [isManagerPage]);

  return (
    <ManagerUserContext.Provider value={{ adminUser, error, loading }}>
      {children}
    </ManagerUserContext.Provider>
  );
}

export const useManagerUser = () => {
  const context = useContext(ManagerUserContext);
  if (!context) {
    throw new Error("useManagerUser must be used within ManagerUserProvider");
  }
  return context;
};
